var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-chart',{staticClass:"h-100",attrs:{"options":_vm.chartOptions,"autoresize":""},on:{"click":_vm.handleGraphClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }